// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Column from '../../components/Column';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import LoginLayout from '../../layouts/LoginLayout';
import { S as LoginLayoutS } from '../../layouts/LoginLayout';

const S = {
  LoginLayout: styled(LoginLayout)`
    ${LoginLayoutS.Card} {
      width: 448px;
    }
  `,
  ResetPasswordFormContainer: styled.div`
    margin-top: 38px;
    height: 100%;
  `,
  Logo: styled.img`
    height: 16px;
    width: 115px;
  `,
  Container: styled(Column)`
    height: 100%;
    width: 100%;
    padding-top: 49px;
    position: relative;
  `,
  HeaderContainer: styled(Column)`
    align-items: center;
  `,
  Title: styled.div`
    margin-top: 33px;
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
  `,
  SubTitle: styled.div`
    margin-top: 9px;
    font-size: 16px;
    line-height: 23px;
    color: #666666;
    text-align: center;
  `,
  GoToLoginPage: styled(Link)`
    font-size: 16px;
    line-height: 23px;
    color: #EF8200;
    justify-content: center;
  `,
  GoToLoginPageWrapper: styled.div`
    position: absolute;
    display: flex;
    top: -16px;
    left: 0px;
    font-size: 16px;
    line-height: 23px;
    color: #EF8200;
  `,
  BackArrow: styled.img`
    height: 9px;
    margin-right: 3px;
    transform: rotate(-90deg);
    color: #EF8200;
  `,
  ResultWrapper: styled(Column)`
    width: 100%;
    margin-top: -25px;
    margin-bottom: 0px;
    position: relative;
    justify-content: space-between;
    align-items: center;
  `,
  ResultImg: styled.img`
    width: 220px;
    height: 220px;
    margin-top: 34px;
  `,
  ResultButton: styled(Button)`
    margin-top: auto;
    min-width: 112px;
    height: 44px;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    margin-top: 40px;
    padding: 7px 11px;
  `,
  ResultTitle: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 33px;
  `,
  ResultDescription: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #666666;
    margin-top: 9px;
    align-items: center;
    justify-content: center;
    margin-top: 9px;
  `,
  ResultDescriptionWrapper: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
  `,
  ResultButtonWrapper: styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 244px;
  `
};

export { S as default }
